export const RECAPTCHA_SITE_KEY = "6Le5POgUAAAAAEGoFEEtGs8669JnY0MIr0El72mM";
export const CONTACT_SALES_LINK =
  "https://www.paypal.com/us/enterprise/contact-sales";
export const VENMO_LOGO = {
  maxSize: "740000",
  requiredDimensions: "1024X1024",
  acceptType: ".png"
};
export const COUNTRIES_REGION_DROPDOWN = ["USA", "CAN", "AUS", "MEX"];
